'use client';

import { IconChevronDown, IconChevronUp, IconDownload, IconX } from '@xefi/x-react/icons';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMainStore } from '@/store';
import { DownloadsPanelItem } from './DownloadsPanelItem';
const TICK_INTERVAL_MS = 1000;
export const DownloadsPanel = () => {
  const {
    t
  } = useTranslation();
  const downloads = useMainStore(state => state.downloads);
  const clearDownloads = useMainStore(state_0 => state_0.clearDownloads);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [nowTimestamp, setNowTimestamp] = useState(() => Date.now());
  const sortedDownloads = useMemo(() => [...downloads].sort((first, second) => second.createdAt.localeCompare(first.createdAt)), [downloads]);
  const activeCount = useMemo(() => downloads.filter(download => download.status === 'inProgress' || download.status === 'finished').length, [downloads]);
  useEffect(() => {
    if (activeCount === 0) return;
    const intervalId = window.setInterval(() => {
      setNowTimestamp(Date.now());
    }, TICK_INTERVAL_MS);
    return () => window.clearInterval(intervalId);
  }, [activeCount]);
  if (downloads.length === 0) return null;
  return <div className='fixed right-4 bottom-4 z-50 w-96 max-w-[calc(100vw-2rem)] overflow-hidden rounded-lg border border-gray-200 bg-white shadow-xl dark:border-gray-700 dark:bg-gray-900'>
         <div className='flex items-center gap-2 border-b border-gray-200 bg-gray-50 px-3 py-2 dark:border-gray-700 dark:bg-gray-800'>
            <IconDownload className='size-4 shrink-0' />
            <span className='flex-1 truncate text-sm font-semibold'>
               {t('downloadHistory.title')}
            </span>
            {activeCount > 0 && <span className='bg-primary shrink-0 animate-pulse rounded-full px-2 py-0.5 text-xs font-bold text-white'>
                  {t('downloadHistory.activeCount', {
          count: activeCount
        })}
               </span>}
            <button type='button' aria-label={isCollapsed ? t('downloadHistory.expand') : t('downloadHistory.collapse')} className='shrink-0 cursor-pointer text-gray-500 hover:text-gray-800 dark:hover:text-gray-200' onClick={() => setIsCollapsed(collapsed => !collapsed)}>
               {isCollapsed ? <IconChevronUp className='size-4' /> : <IconChevronDown className='size-4' />}
            </button>
            <button type='button' aria-label={t('downloadHistory.clearAll')} className='shrink-0 cursor-pointer text-gray-500 hover:text-gray-800 dark:hover:text-gray-200' onClick={clearDownloads}>
               <IconX className='size-4' />
            </button>
         </div>
         {!isCollapsed && <ul className='max-h-80 divide-y divide-gray-100 overflow-y-auto dark:divide-gray-800'>
               {sortedDownloads.map(download_0 => <DownloadsPanelItem key={download_0.id} download={download_0} nowTimestamp={nowTimestamp} />)}
            </ul>}
      </div>;
};